import styled, { css } from "styled-components";

export const Header = styled.div`
  margin-bottom: 16px;
`;

export const PaticipantsList = styled.div`
  width: 100%;
  min-height: 400px;
  margin-top: 36px;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
`;

export const ListRow = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  padding: 16px;
  color: #fff;

  ${(props) =>
    props.isHeader
      ? css`
          background: #031795;
        `
      : css`
          background: #fff;
          color: #000;
        `}

  ${(props) =>
    !props.isHeader &&
    css`
      border-top: 1px solid #e0e0e0;
    `}

  div {
    display: flex;
  }
`;

export const ParticipantRowItemContainer = styled.div`
  display: flex;
  align-items: center;

  .MuiAutocomplete-root.MuiAutocomplete-hasClearIcon.MuiAutocomplete-hasPopupIcon {
    width: 100%;
  }
`;

export const CheckAttendanceButton = styled.div`
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  display: flex;
  align-items: center;
  justify-content: center;

  width: 26px;
  height: 26px;

  border-radius: 50%;

  background: ${(props) => (props.selected ? "#64b246" : "#e0e0e0")};

  svg {
    color: #fff;
  }
`;

export const CheckNonAttendanceButton = styled.div`
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  display: flex;
  align-items: center;
  justify-content: center;

  margin-left: 6px;
  width: 26px;
  height: 26px;

  border-radius: 50%;

  background: ${(props) => (props.selected ? "#E11021" : "#e0e0e0")};

  svg {
    color: #fff;
  }
`;
export const ConcludeButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
`;

export const Container = styled.div``;
